import { Box, Typography, useTheme } from "@mui/material";
import React, { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import OrderHeader from "../components/OrderHeader/OrderHeader";
import Entry from "../Entry/Entry";
import OrderStatusStepper from "../Shell/components/OrderStatusStepper/OrderStatusStepper";
import { Order, OrderServiceType, OrderStatus, OrderType } from "../types";

interface DummyOrderCreationPageProps {
  orderType: OrderType;
  children: ReactNode;
}

const DummyOrderCreationPage: FC<DummyOrderCreationPageProps> = ({
  orderType,
  children,
}) => {
  const theme = useTheme();
  const { t } = useTranslation("orders");

  const dummyOrder = {
    orderNumber: "--",
    orderType,
    orderStatus: OrderStatus.UNSUBMITTED,
    lastUpdatedBy: " ",
    client: " ",
    orderConsolidation: true,
    orderServiceType: OrderServiceType.DELIVERY,
    lines: [],
  } as unknown as Order;

  return (
    <Box data-testid="dummy-order-creation-page">
      <Box
        sx={{
          paddingBottom: theme.tokens.FuelSpacing6,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          component="h1"
          data-fuel-size="3xl"
          color={theme.tokens.FuelColorTextPrimary}
          fontWeight={theme.tokens.FuelFontWeightRegular}
          data-testid="order-creation-header"
        >
          {t("order.header.title")}
        </Typography>
      </Box>
      <OrderStatusStepper activeStepIndex={0} />
      <OrderHeader step={0} order={dummyOrder} />
      <Entry
        order={dummyOrder}
        save={() => {}}
        continueToNextButton={undefined}
        cancelOrderButton={undefined}
      />
      {children}
    </Box>
  );
};

export default DummyOrderCreationPage;
